import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'notification-alert',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    animations: [
        trigger('EnterLeave', [
            state('flyIn', style({ transform: 'translateX(0)' })),
            state('toLeft', style({
                transform: 'translateX(-100px)',
                display: 'none'
            })),
            state('toRight', style({
                transform: 'translateX(-100px)',
                display: 'block'
            })),
            transition('toRight=>flyIn', animate('600ms')),
            transition('flyIn=>toLeft', animate('600ms'))
        ])
    ],
    standalone: false
})
export class NotificationComponent implements OnInit, OnChanges {
    @Input() notificationMessage: any = {};
    currentAnimationState: any;
    constructor() {
        this.currentAnimationState = "flyIn";
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.currentAnimationState = "toRight";
        if (!changes.firstChange) {
            setTimeout(() => {
                this.currentAnimationState = "flyIn";
            }, 0);

            setTimeout(() => {
                this.currentAnimationState = "toLeft";
            }, 4000);
        }
    }

}
